import React, { useCallback } from "react";
import ReusableModal from "../../../../components/Modals/ReusableModal";
import Select from "react-select";
import {
  useFetchPlannerZonesMutation,
  useUpsertZoneLocationsMutation,
} from "../../../../features/zones/zonesApiSlice";
import debounce from "lodash.debounce";
const ProviderZoneEditModal = ({
  open,
  setOpen,
  provider,
  updateProviderZones,
}) => {
  const [zones, setZones] = React.useState([]);
  const [selectedZones, setSelectedZones] = React.useState(
    provider?.zones?.map((zone) => ({
      value: zone.id,
      label: zone.name,
    }))
  );

  React.useEffect(() => {
    setSelectedZones(
      provider?.zones?.map((zone) => ({
        value: zone.id,
        label: zone.name,
      }))
    );
  }, [provider?.zones]);

  const handleSelectedZones = (selectedZones) => {
    setSelectedZones(selectedZones);
  };

  const [fetchPlannerZones, { isLoading: zonesLoading }] =
    useFetchPlannerZonesMutation();

  const [upsertZoneLocations, { isLoading: upsertZoneLocationsLoading }] =
    useUpsertZoneLocationsMutation();

  const fetchZones = async (inputValue, initial = false) => {
    try {
      setZones([]);

      if (!inputValue && !initial) return;

      const { data } = await fetchPlannerZones({
        search: inputValue.trim(),
        providerIds: [],
        patientIds: [],
        zoneIds: [],
        take: 50,
      }).unwrap();

      const zones = data.map((data) => ({
        label: data.name,
        value: data.id,
      }));

      setZones(zones);
    } catch (error) {
      console.log("Error fetching locations:", error);
    }
  };

  const fetchZonesDebounced = useCallback(
    debounce((inputValue, initial = false) => fetchZones(inputValue, initial)),
    200
  );

  const handleSave = async () => {
    try {
      console.log({
        locationId: provider.locationId,
        type: "PROVIDER_HOME",
        zoneIds: selectedZones.map((zone) => zone.value),
      });

      await upsertZoneLocations({
        locationId: provider.locationId,
        type: "PROVIDER_HOME",
        zoneIds: selectedZones.map((zone) => zone.value),
      }).unwrap();

      updateProviderZones(
        provider.locationId,
        selectedZones.map((zone) => ({ id: zone.value, name: zone.label }))
      );

      setOpen(false);
    } catch (error) {
      console.log("Error updating patient zones:", error);
    }
  };

  return (
    <ReusableModal
      open={open}
      title="Edit Zone"
      onClose={() => {
        setOpen(false);
      }}
    >
      <div className="p-8 w-[600px] h-[450px]">
        <Select
          placeholder="Search by Zone..."
          isSearchable
          isClearable
          className="overflow-visible w-full h-9"
          isMulti
          value={selectedZones}
          onChange={handleSelectedZones}
          options={zones}
          noOptionsMessage={() => "Search By Name..."}
          isLoading={zonesLoading}
          onMenuOpen={() => fetchZones("", true)}
          onInputChange={(inputValue, { action }) => {
            if (action === "input-change") {
              fetchZonesDebounced(inputValue);
            }
          }}
          menuPortalTarget={document.body}
          maxMenuHeight={200}
          styles={{
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999,
            }),
            menuList: (base) => ({
              ...base,
              overflowY: "auto",
            }),
            valueContainer: (base) => ({
              ...base,
              maxHeight: "400px",
              overflowY: "auto",
              paddingTop: "2px",
              paddingBottom: "2px",
            }),
            control: (base) => ({
              ...base,
              minHeight: "36px",
              height: "auto",
              maxHeight: "420px",
            }),
          }}
        />
      </div>
      <div className="p-3">
        <button
          onClick={handleSave}
          className="p-2 w-full text-white rounded-md bg-primaryblue"
        >
          Save
        </button>
      </div>
    </ReusableModal>
  );
};

export default ProviderZoneEditModal;
